import React, {useEffect, useState} from "react";
import PaginatedTable from "../../../../../components/table/paginated-table/paginated-table";
import cn from "classnames";
import TableCell from "@material-ui/core/TableCell";
import {FormattedMessage, injectIntl} from "react-intl";
import styles from "../../../../source/table/styles.css";
import withStyles from "../../../../../components/with-styles/with-styles";
import TableRow from "@material-ui/core/TableRow";
import CustomTableRow from "../../../../../components/table/custom-table-row/custom-table-row";
import Link from "../../../../../components/link/link";
import SourceThumbnail from "../../../../../components/thumbnail/source-thumbnail/source-thumbnail";
import OptionalDate from "../../../../../components/optional-date/optional-date";
import TextDisplay from "../../../../../components/display-data/text/text";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import {GENERAL_STATUS_KO} from "../../../../../utils/constants";

const RowComponent = ({
                          classes,
                          intl,
                          item,
                          showDeployment,
                      }) => {

    const [camera, setCamera] = useState(null);

    const isKo = camera?.lastStatus === GENERAL_STATUS_KO;
    const sourceList = useSelector(state => state.commonState.sourceList);

    useEffect(() => {
        if (sourceList) {
            setCamera(sourceList.find(source => source.id === item))
        }
    }, [sourceList]);

    return (camera ? <CustomTableRow key={camera} className={cn(classes.listRow, {[classes.alert]: isKo})}>
        {showDeployment && (
            <TableCell>
                {camera.deployment && (
                    <Link className={classes.alertLink} color="primary"
                          href={`/deployment/details/${camera.deployment.id}`}>
                        {camera.deployment.codename}
                    </Link>
                )}
            </TableCell>
        )}
        <TableCell>
            <div>
                {camera.type === "camera" && Boolean(camera.lastThumbnail) &&
                <SourceThumbnail width={150} source={camera}/>}
            </div>
            <div className={cn({[classes.alertText]: isKo})}>
                <OptionalDate value={camera.lastChecked}/>
            </div>
            <div>{camera.description}</div>
        </TableCell>
        <TableCell>
            <div className={classes.title}>{camera.brand}</div>
            <div className={classes.code}>{camera.model}</div>
            <div>
                <FormattedMessage id="source.serial"/>
                <div className={classes.code}>{camera.serial}</div>
            </div>
        </TableCell>
        <TableCell>
            <div>
                <TextDisplay label={intl.formatMessage({id: "common.type"})}>{camera.type}</TextDisplay>
            </div>
            <div>
                <TextDisplay label={intl.formatMessage({id: "source.use"})}>{camera.use}</TextDisplay>
            </div>
            <div>
                <TextDisplay label={intl.formatMessage({id: "source.owner"})}>{camera.owner}</TextDisplay>
            </div>
        </TableCell>
    </CustomTableRow> : <></>);
};

RowComponent.propTypes = {
    /**
     ** Indica si muestra un enlace a la instalación
     **/
    showDeployment: PropTypes.bool,
    /**
     ** Elemento a representar en la fila de la tabla
     **/
    item: PropTypes.object,
    /**
     * Función de refetch de datos
     */
    refetchData: PropTypes.func.isRequired,
    /**
     ** Indica si se muestran los controles de borrar la asociación con el deployment
     **/
    showDeploymentAssociationControls: PropTypes.bool,
};

const I18nStyledRowComponent = injectIntl(withStyles(styles)(RowComponent));

const Header = () => (
    <TableRow/>
);

const CameraListTable = ({cameras}) => {
    return (
        <PaginatedTable
            paginatedElements={{items: cameras, total: cameras?.length}}
            headerComponent={Header}
            rowComponent={I18nStyledRowComponent}
            perPage={5}
            showPagination={false}
        />
    )
};

export default CameraListTable;